'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var SearchCriteriaController = function SearchCriteriaController($scope, $rootScope, $q, $log, momentService, navigationHistoryService, currentStateCriteriaService, searchCriteriaService, keyboardSupport, searchCriteriaRsqlQueryService, searchCriteriaConstantsService, optWeekRuleOperatorService) {
  function resetProperties() {
    $scope.showDuplicateNameWarning = false;
    $scope.saveAsName = '';
  }
  resetProperties();
  $scope.currentSelectedSearch = null;
  $scope.hoveredRow = null;
  $scope.showNoResultsWarning = false;
  $scope.showSuccess = false;
  $scope.storedCriteria = [];
  $scope.screen = $scope.initialScreen;
  $scope.flightManagementMode = {
    visible: false
  };
  $scope.singleCustomSearchMode = function () {
    return $scope.customSearchModes && $scope.customSearchModes.length === 1;
  };
  $scope.multiCustomSearchMode = function () {
    return $scope.customSearchModes && $scope.customSearchModes.length > 1;
  };
  $scope.selectedCustomMode = $scope.multiCustomSearchMode() ? $scope.customSearchModes[0] : false;
  currentStateCriteriaService.emptySearchCriteria();
  $scope.openDialogActions = function () {
    resetProperties();
    keyboardSupport.addHotKeys($scope);
  };
  $scope.closeDialogActions = function () {
    keyboardSupport.removeHotKeys();
    resetProperties();
  };
  $scope.loadSavedSearchCriteria = function () {
    return searchCriteriaService.get($scope.screen).then(function (data) {
      $scope.storedCriteria = _.sortBy(data, 'name');
    });
  };
  $scope.loadSavedSearchCriteria();
  $scope.unchangedSearchCriteria = function () {
    if ($scope.defaultSearchCriteria) {
      return currentStateCriteriaService.unchangedSearchCriteria($scope.defaultSearchCriteria);
    }
    return true;
  };
  $scope.loadProvidedSearchCriteria = function (transitionData) {
    currentStateCriteriaService.loadSearchCriteria(transitionData.searchCriteria, transitionData.searchCriteria.customSearchMode, transitionData.rsqlOverride);
    $scope.screen = transitionData.searchCriteria.context;
    $scope.customSearchMode = transitionData.searchCriteria.customSearchMode;
    return $q.when();
  };
  $scope.loadDefaultSearchCriteria = function (isPostDptrModeChange) {
    var defaultMode = $scope.multiCustomSearchMode() ? $scope.selectedCustomMode.mode : undefined;
    return searchCriteriaService.getDefault($scope.screen, defaultMode, $scope.defaultListing).then(function (data) {
      if (isPostDptrModeChange) {
        currentStateCriteriaService.handlePostDepartureModeChange($scope.screen, $scope.customSearchMode);
      } else {
        currentStateCriteriaService.loadSearchCriteria(data, $scope.customSearchMode);
      }
      $scope.dismissNoResultsWarning();
      $scope.defaultSearchCriteria = data;
      $scope.currentSelectedSearch = null;
      $scope.saveAsName = null;
    });
  };
  $scope.getSearchCriteria = function () {
    return currentStateCriteriaService.getSearchCriteria();
  };
  $scope.getRules = function () {
    var searchCriteria = currentStateCriteriaService.getSearchCriteria();
    return searchCriteria && searchCriteria.context === $scope.screen ? searchCriteria.rules : [];
  };
  $scope.getVisibleRules = function () {
    var searchCriteria = $scope.getRules();
    return _.transform(searchCriteria, function (result, rule) {
      if (rule.isHidden !== true) {
        result.push(rule);
      }
    });
  };
  $scope.addSearchCriteriaRule = function () {
    if (currentStateCriteriaService.isValid()) {
      currentStateCriteriaService.addSearchCriteriaRule();
    }
  };
  $scope.isAddingNewSearchCriteriaRuleAvailable = function (isLast) {
    return isLast && currentStateCriteriaService.isValid() && !$scope.onlyOneCriteriaRowAllowed;
  };
  $scope.removeSearchCriteriaRule = function (index) {
    if ($scope.isNotTheOnlyRule()) {
      currentStateCriteriaService.removeSearchCriteriaRule(index);
    }
  };

  /**
   * This apply only for some Search Modal where screen is not the same
   * as the current screen.
   *
   * TODO:
   * Check if can be change on easy way if not we need to mantain this function.
   * @param screen current screen name
   */
  function fixScreenName(screen) {
    var transformations = {
      'system-status-flight-sent': 'system-status',
      'system-status-service-sent': 'system-status',
      'system-conf-user-defined-ref-data-market': 'system-configuration',
      'system-status-interface-status': 'system-status',
      'system-status-fares-reopt': 'system-status'
    };
    if (typeof transformations[screen] === 'undefined') {
      return screen;
    }
    return transformations[screen];
  }

  // each time we trigger a search (no matter if it is user-triggered - Search button, loading defaults)
  $scope.triggerSearch = function (transitionData) {
    //clear alert search rules if the user executes a manual search
    if (transitionData === undefined && ($scope.screen === searchCriteriaConstantsService.MARKET_ANALYSIS || $scope.screen === searchCriteriaConstantsService.FLIGHT_ANALYSIS)) {
      currentStateCriteriaService.clearAlertSearch();
      currentStateCriteriaService.clearRsqlOverrideSearch();
    }
    var searchCriteria = currentStateCriteriaService.copySearchCriteria($scope.getSearchCriteria());
    if (optWeekRuleOperatorService.isOptWeekRuleEmpty(searchCriteria.rules)) {
      $scope.$emit('search-criteria:no-results');
      return false;
    }
    navigationHistoryService.saveState({
      screen: fixScreenName($scope.initialScreen),
      timestamp: momentService.now(momentService.FIELD.EVENT_TIME_STAMP),
      searchCriteria: searchCriteria
    });
    if (searchCriteria.context === $scope.screen) {
      $scope.triggerSearchCallback(transitionData);
    }
    return true;
  };
  $scope.broadcastSearchButtonClick = function () {
    $rootScope.$broadcast('search-criteria:onSearchButtonClick');
  };
  $scope.loadLastSearchCriteria = function () {
    var lastHistoryState = navigationHistoryService.getHistory()[0];
    if (lastHistoryState.state.screen === $scope.screen) {
      currentStateCriteriaService.loadSearchCriteria(lastHistoryState.state.searchCriteria, $scope.customSearchMode);
    }
  };
  $scope.clearSearchCriteria = function () {
    $scope.loadDefaultSearchCriteria();
  };
  function storedCriteriaExists() {
    return $scope.storedCriteria && $scope.storedCriteria.length > 0 ? _.findIndex($scope.storedCriteria, $scope.currentSelectedSearch) > -1 : true;
  }
  function loadSearchCriteria() {
    if ($scope.currentSelectedSearch && storedCriteriaExists()) {
      currentStateCriteriaService.loadSearchCriteria($scope.currentSelectedSearch, $scope.customSearchMode);
      $scope.saveAsName = null;
      selectCustomMode();
    }
  }
  function selectCustomMode() {
    if ($scope.multiCustomSearchMode()) {
      $scope.selectedCustomMode = _.find($scope.customSearchModes, {
        mode: $scope.currentSelectedSearch.customSearchMode
      });
      if ($scope.searchModeChangeCallback) {
        $scope.searchModeChangeCallback($scope.selectedCustomMode.mode);
      }
    }
  }
  $scope.isFormDisabled = function () {
    return !currentStateCriteriaService.isValid();
  };
  $scope.isSaveDisallowed = function () {
    return !$scope.saveAsName || $scope.isFormDisabled();
  };
  var addToStoredCriteria = function addToStoredCriteria(criteria) {
    var toReplace = _.findIndex($scope.storedCriteria, {
      name: criteria.name
    });
    if (hasDuplicates($scope.storedCriteria, $scope.saveAsName)) {
      $scope.storedCriteria[toReplace] = criteria;
    } else {
      $scope.storedCriteria.push(criteria);
    }
  };
  function hasDuplicates(arr, name) {
    return _.findIndex(arr, {
      name: name
    }) !== -1;
  }
  $scope.checkDuplicatesAndSave = function () {
    if (hasDuplicates($scope.storedCriteria, $scope.saveAsName)) {
      $scope.dismissSuccessMessage();
      $scope.showDuplicateNameWarning = true;
    } else {
      $scope.saveCriteria(false);
    }
  };
  $scope.saveCriteria = function (overwrite) {
    $scope.dismissSaveWarning();
    var criteria = currentStateCriteriaService.prepareForSaving();
    criteria.name = $scope.saveAsName;
    criteria.context = $scope.screen;
    if ($scope.multiCustomSearchMode()) {
      criteria.customSearchMode = $scope.selectedCustomMode.mode;
    }
    addToStoredCriteria(criteria);
    $scope.saveAsName = '';
    searchCriteriaService.save(criteria, overwrite).then($scope.showSuccessMessage, $scope.showError);
  };
  $scope.criteriaRuleUpdated = function () {
    if ($scope.currentSelectedSearch) {
      $scope.saveAsName = $scope.currentSelectedSearch.name;
    }
    $scope.dismissNoResultsWarning();
  };
  $scope.dismissSaveWarning = function () {
    $scope.showDuplicateNameWarning = false;
  };
  $scope.dismissNoResultsWarning = function () {
    $scope.showNoResultsWarning = false;
  };
  $scope.appearNoResultsWarning = function () {
    $scope.showNoResultsWarning = true;
  };
  $scope.showSuccessMessage = function () {
    $scope.showSuccess = true;
  };
  $scope.dismissSuccessMessage = function () {
    $scope.showSuccess = false;
  };
  $scope.showError = function (response) {
    var errorMsg = 'Error while saving criteria: ' + response.statusText + ' (code ' + response.status + ')';
    $log.error('SearchCriteriaController: showError - ' + errorMsg);
    toastr.error(errorMsg);
  };
  $scope.isNotTheOnlyRule = function () {
    var criteriaLength = currentStateCriteriaService.getSearchCriteria().rules.length;
    if ($scope.screen === 'market-analysis' || $scope.screen === 'fares' || $scope.screen === 'rom-analysis' || $scope.screen === 'rom-summary') {
      return criteriaLength > 2;
    } else {
      return criteriaLength > 1;
    }
  };
  $scope.onSearchCriteriaChange = function () {
    loadSearchCriteria();
  };
  $scope.mouseEnterAction = function ($index) {
    $scope.hoveredRow = $index;
  };
  $scope.mouseLeaveAction = function () {
    $scope.hoveredRow = null;
  };
  $scope.showRowSpecificIcon = function ($index, criteria) {
    return $scope.hoveredRow === $index && $scope.isNotTheOnlyRule() && !criteria.isReadOnly;
  };
  $scope.setCustomSearchMode = function () {
    if ($scope.singleCustomSearchMode()) {
      $scope.customSearchMode = $scope.selectedCustomMode ? $scope.customSearchModes[0].mode : undefined;
    } else if ($scope.multiCustomSearchMode()) {
      $scope.customSearchMode = $scope.selectedCustomMode.mode;
    }
    if ($scope.searchModeChangeCallback) {
      $scope.searchModeChangeCallback($scope.customSearchMode);
    }
  };
  $scope.$on('flight-analysis-toggle:toggleMode', function ($event, mode) {
    $scope.flightManagementMode.visible = mode === 'flight-management';
  });
  $scope.isCustomSearchVisible = function () {
    return $scope.singleCustomSearchMode() && (!$scope.flightManagementMode.visible || $scope.screen === searchCriteriaConstantsService.FARES_OPTIMIZER);
  };
  $scope.onStateChangeSuccess = function (event, toState, toParams) {
    searchCriteriaRsqlQueryService.clearSerializedQueryCache();
    var loadingPromise;
    if (toParams && toParams.transitionData) {
      if (!toParams.transitionData.skipSearch) {
        loadingPromise = $scope.loadProvidedSearchCriteria(toParams.transitionData);
        searchCriteriaService.getDefault($scope.screen, $scope.defaultListing).then(function (data) {
          $scope.defaultSearchCriteria = data;
        });
      } else {
        loadingPromise = $scope.loadDefaultSearchCriteria();
      }
    } else {
      loadingPromise = $scope.loadDefaultSearchCriteria();
    }
    loadingPromise.then(function () {
      $scope.triggerSearch(toParams);
    });
  };
  $scope.$watch('customSearchModes', function (newVal) {
    if (newVal && newVal.length) {
      $scope.selectedCustomMode = $scope.customSearchModes[0];
    }
  });
  $scope.handleScreenAndModeChange = function (newValuesArray, oldValuesArray) {
    var newValues = {
      screen: newValuesArray[0],
      customSearchMode: newValuesArray[1]
    };
    var oldValues = {
      screen: oldValuesArray[0],
      customSearchMode: oldValuesArray[1]
    };
    if (_.isEqual(newValues.screen, oldValues.screen) && _.isEqual(newValues.customSearchMode, oldValues.customSearchMode) || _.isEqual(newValues.screen, oldValues.screen) && _.isEqual(oldValues.screen, searchCriteriaConstantsService.MARKET_ANALYSIS)) {
      return;
    }
    var isPostDptrModeChange = false;
    if (_.includes([newValues.screen, oldValues.screen], searchCriteriaConstantsService.FLIGHT_ANALYSIS_POST_DEPARTURE) || _.includes([newValues.customSearchMode, oldValues.customSearchMode], searchCriteriaConstantsService.SEARCH_MODES.POST_DEPARTURE) || _.includes([newValues.customSearchMode, oldValues.customSearchMode], searchCriteriaConstantsService.FO_SEARCH_MODES.RETRIEVE_LAST_SNAPSHOT)) {
      isPostDptrModeChange = true;
    }
    $scope.loadDefaultSearchCriteria(isPostDptrModeChange);
    $scope.loadSavedSearchCriteria();
  };
};
SearchCriteriaController.$inject = ['$scope', '$rootScope', '$q', '$log', 'MomentService', 'NavigationHistoryService', 'CurrentStateCriteriaService', 'SearchCriteriaService', 'SearchCriteriaKeyboardSupportService', 'SearchCriteriaRsqlQueryService', 'SearchCriteriaConstantsService', 'OptWeekRuleOperatorService'];
module.exports = SearchCriteriaController;